<template>
  <div class="home">
    <Header :title="content.header_title" :subTitle="content.header_subtitle" />
    <div class="container">
      <div class="row mt-5">
        <div class="col-sm-8">
          <h2 class="mt-4">{{content.content_title}}</h2>
          <div v-html="content.content"></div>
          <p>
            <router-link :to="content.button_link || '/'"
                         class="btn btn-outline-primary btn-lg custom-padding">
              {{content.button_text}}</router-link>
          </p>
        </div>
        <div class="col-sm-4 d-none d-md-block">
          <h2 class="mt-4">{{ content.contacts_title}}</h2>
          <address v-html="content.contacts_adress">
          </address>
          <address>
            <abbr :title="content.contacts_phone_title">{{content.contacts_phone_title}}</abbr>
            <a :href="`tel:${content.contacts_phone}`"> {{ content.contacts_phone}}</a>
            <br>
            <abbr title="Email">Email:</abbr>
            <a :href="`mailto:${content.contacts_email}`"> {{ content.contacts_email}}</a>
          </address>
        </div>
      </div>
      <div class="row mt-5">
        <feature-item v-for="feature in features" :key="feature._id" :feature="feature"/>
      </div>
      <div class="row mt-2 d-md-none">
        <div class="col-12">
          <h2 class="mt-4">{{ content.contacts_title}}</h2>
          <address v-html="content.contacts_adress">
          </address>
          <address>
            <abbr :title="content.contacts_phone_title">{{content.contacts_phone_title}}</abbr>
            <a :href="`tel:${content.contacts_phone}`"> {{ content.contacts_phone}}</a>
            <br>
            <abbr title="Email">Email:</abbr>
            <a :href="`mailto:${content.contacts_email}`"> {{ content.contacts_email}}</a>
          </address>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeatureItem from '@/components/FeatureItem.vue';
import Header from '@/components/Header.vue';
import Api from '@/api';
import store from '@/store';
import filterObject from '@/util/lang';

export default {
  name: 'home',
  components: {
    Header,
    FeatureItem,
  },
  data() {
    return {
      content: {},
      features: [],
    };
  },
  methods: {
    getContent() {
      Api.getContentMain()
        .then(page => filterObject(page, store.getters.lang))
        .then((page) => {
          this.content = page;
        });
      Api.getFeatures()
        .then(features => features.map(el => filterObject(el, store.getters.lang)))
        .then((page) => {
          this.features = page;
        });
    },
  },
  created() {
    this.getContent();
    store.watch(state => state.lang, () => {
      this.getContent();
    });
  },
};
</script>

<style>
  .custom-padding {
    padding-left: 40px;
    padding-right: 40px;
  }
</style>
